<template>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">Edit Game Settings</p>
      <button type="button" class="delete" @click="$emit('close')" />
    </header>
    <section class="modal-card-body">
      <b-field label="Tickets">
        <b-input v-model="limit" type="number" readonly disabled placeholder="number of tickets"></b-input>
      </b-field>

      <b-field label="Game Type">
        <GameTypeFields v-model="gameType" />
      </b-field>

      <b-field label="Schedule date and time">
        <b-datetimepicker
          v-model="time"
          :mobile-native="false"
          :timepicker="timepicker"
          placeholder="Select a date"
          icon="calendar-today"
        ></b-datetimepicker>
      </b-field>

      <b-field label="Price per ticket">
        <b-input v-model.number="per_ticket" type="number" min="0" placeholder="100"></b-input>
      </b-field>

      <b-field label="Commision per ticket">
        <b-input v-model.number="commission" type="number" min="0" placeholder="20"></b-input>
      </b-field>
    </section>
    <footer v-show="loaded" class="modal-card-foot">
      <template v-if="status === 'schedule'">
        <button type="button" class="button is-primary" @click="edit()">Save</button>
        <button type="button" class="button is-warning" @click="stopGame()">Cancel Game</button>
      </template>
      <button v-if="status === 'stop'" type="button" class="button" @click="duplicate()">Reschedule</button>
    </footer>
  </div>
</template>

<script>
  import GameTypeFields from "./GameTypeFields.vue";
  import { defaultScheduleTime, enabledGameTypes } from "../constants/game";

  export default {
    name: "GameInfo",
    components: { GameTypeFields },
    data() {
      return {
        limit: 600,
        time: defaultScheduleTime(),
        status: "",
        gameId: null,
        loaded: false,
        reschedule: false,
        per_ticket: "",
        commission: "",
        gameType: {},
        timepicker: {
          incrementMinutes: 15,
          incrementHours: 1,
          hourFormat: "12"
        }
      };
    },
    methods: {
      // Called by the parent once the game_info callable resolves.
      setup({ id, data }) {
        this.reschedule = false;
        this.loaded = true;
        if (!data) return;

        this.gameId = id;
        this.status = data.data.status;
        this.per_ticket = data.data.per_ticket;
        this.commission = data.data.commission;
        this.limit = data.data.limit;
        this.time = new Date(data.data.schedule._seconds * 1000);
        this.gameType = data.types || {};
      },
      stopGame() {
        this.$emit("stopGame", this.gameId);
        this.$parent.close();
      },
      duplicate() {
        this.$buefy.dialog.confirm({
          message: "This game will be reschedule with same tickets.",
          confirmText: "Reschedule Game",
          type: "is-primary",
          onConfirm: () => {
            this.reschedule = true;
            this.edit();
          }
        });
      },
      edit() {
        this.$emit("EditGame", {
          gameId: this.gameId,
          time: this.time.getTime(),
          reschedule: this.reschedule,
          gameType: enabledGameTypes(this.gameType)
        });
        this.$parent.close();
      }
    }
  };
</script>
